// @style
import { useThemeStore } from "../../store/useThemeStore";
import "./StyleSpinner.css"

// @store
import { useSpinnerStore } from "../../store/useSpinnerStore"

const Spinner = () => {
    const { open } = useSpinnerStore();
    const { isDarkMode } = useThemeStore();

    return (
        <div className={!open ? "hidden" : `fixed w-full h-screen bg-transparent z-[100] ${isDarkMode ? "dark" : ""}`}>
            <div className="flex items-center justify-center h-screen w-full bg-black/50 dark:bg-white/10 pointer-events-none">
                <div className="loader"></div>
            </div>
        </div>
    )
}

export default Spinner